import type {TokenErrorResponse} from "@App/apis/rest/ayvens/token/tokenErrorResponse";

/**
 * Custom error class for authentication failures (HTTP 401).
 */
export class TokenError extends Error {
    public response: TokenErrorResponse
    constructor(error: TokenErrorResponse) {
        super(error.message);
        this.response = error
        this.name = "TokenError";
    }
}
